import React, { PropsWithChildren } from "react";
import "./layoutCard.css";

export function LayoutCard({ children }: PropsWithChildren) {
  return <div className="layout-card">{children}</div>;
}
